const state = () => {
  return {
    menu_guest: [
      {
        icon: "HomeIcon",
        pageName: "home",
        title: "Home"
      },
      {
        icon: "LogInIcon",
        pageName: "login",
        title: "Sign in"
      },
      {
        icon: "PhoneOutgoingIcon",
        pageName: "contactas",
        title: "Contact us"
      }
    ],
    menu_user: [
      {
        icon: "HomeIcon",
        pageName: "home",
        title: "Home"
      },
      {
        icon: "TrelloIcon",
        pageName: "user-aria",
        title: "User area"
      },
      {
        icon: "PhoneOutgoingIcon",
        pageName: "contactas",
        title: "Contact us"
      },
      {
        icon: "LogOutIcon",
        pageName: "logout",
        title: "Logout"
      }
    ],
    menu_admin: [
      {
        icon: "HomeIcon",
        pageName: "home",
        title: "Home"
      },
      {
        icon: "TrelloIcon",
        pageName: "user-aria",
        title: "User area"
      },
      {
        icon: "PhoneOutgoingIcon",
        pageName: "contactas",
        title: "Contact us"
      },
      {
        icon: "TrelloIcon",
        pageName: "admin-aria",
        title: "Admin area"
      },
      {
        icon: "CrosshairIcon",
        pageName: "bionet-tool",
        title: "Bionet tool"
      },
      {
        icon: "MapIcon",
        pageName: "vegetation-bionet-tool",
        title: "Vegetation bionet tool"
      },
      {
        icon: "TrelloIcon",
        pageName: "pmstProfile",
        title: "Profile PMST"
      },
      {
        icon: "TrelloIcon",
        pageName: "bionet_upload",
        title: "Upload bionet file"
      },
      {
        icon: "TrelloIcon",
        pageName: "specifies",
        title: "Upload species file"
      },
      {
        icon: "LogOutIcon",
        pageName: "logout",
        title: "Logout"
      }
    ]
  };
};

// getters
const getters = {
  menu_guest: state => state.menu_guest,
  menu_user: state => state.menu_user,
  menu_admin: state => state.menu_admin
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
